import MGUtils from "@tp/h5utils";
import cookie from "js-cookie";
import httpUtils from "./http";
import Api from "./api";
import ua from "@tp/ua";
import Vue from "vue";
import store from "../store";

const mgApiParse = (data) => {
  if (data === "") {
    return null;
  }

  if (typeof data === "string") {
    return JSON.parse(data);
  }

  return data;
};

export const isPc = () => {
  return window.innerWidth > 500;
};

export const login = () => {
  if (isPc()) {
    Vue.prototype.$EventBus.$emit("showLogin", true);
    return;
  }

  MGUtils.allLogin().then(() => {
    window.location.reload();
  });
};

export const logout = () => {
  cookie.remove("HDCN", { domain: ".mgtv.com" });
  cookie.remove("ticket", { domain: ".mgtv.com" });
  logOutInfo();
};

/**获取用户手机号 */
const getUserMobile = async (ticket) => {
  const res = await httpUtils.jsonp(Api.getUserInfo, {
    ticket,
    invoker: "jmcp",
  });

  return (res.data || {}).relate_mobile;
};

/**mgtv 所有场景获取用户信息 */
const allGetUserInfo = async () => {
  return new Promise((resolve) => {
    /**设置超时时间 */
    const timer = setTimeout(() => {
      console.warn("获取用户信息超时");
      resolve(null);
    }, 5000);

    MGUtils.allGetUserData()
      .then((data) => {
        if (!data) {
          throw new Error("未登录");
        }

        resolve(mgApiParse(data));
        clearTimeout(timer);
      })
      .catch((error) => {
        console.log("未能获取用户登录信息:", error);
        clearTimeout(timer);
        resolve(null);
      });
  });
};

/**
 * 获取用户信息
 * @returns Promise
 */
export const getUserInfo = async () => {
  let data = await allGetUserInfo();

  if (!data) {
    console.warn("获取用户登录信息失败");
    logout();
    return;
  }

  /**芒果App内手机号为空，额外再请求一次，防止h5触发绑定手机号后，app未更新绑定手机号 */
  if (ua.isImgo()) {
    const relate_mobile = await getUserMobile(data.ticket);
    if (relate_mobile) {
      data.relate_mobile = relate_mobile;
    }
  }

  return {
    avatar: data.avatar.l,
    nickname: data.nickname,
    uuid: data.uuid,
    ticket: data.ticket,
    mobile: data.relate_mobile,
  };
};

/**H5退出登录*/
export const logOutInfo = () => {
  const { ticket } = store.state.userInfo;
  if (!ticket) return;
  httpUtils.post(Api.logout, {
    ticket,
    invoker: "jmcp",
  });
};
